module.exports = __webpack_public_path__ + "static/leaf-1525de0c2634d77b924db600fcaf0f54.png";